import React from 'react';
import ParentDetails from '../../pages/LogInPage/ParentDetails';

const AddParentDetails = () => {
  return (
    <div className="gap-9 flex flex-col items-center p-6 pb-9 bg-satPrepFrostedWhite backdrop-blur-[20px] shadow-dialog border-[0.5px] border-satPrepGrey rounded-[28px]">
      <h1 className="font-gully text-[40px] font-bold text-center text-satPrepAccent">
        Add Parent Details
      </h1>
      
      <ParentDetails isDashboard />
    </div>
  );
};

export default AddParentDetails;

